// const baseconfig = {
//   xinextendUrlapi:'https://apidev.xin-ptt.com:9001/xinextend',
//   apiAudioUrl: "https://apidev.xin-ptt.com:9001/xinAudio", //测试录音文件平台
//   gpsUrlapi: "https://apidev.xin-ptt.com:9001/xingps", //测试定位地址
//   mmsUrlapi: "https://apidev.xin-ptt.com:9001/mms", //广播
//   videoUrlapi: "https://apidev.xin-ptt.com:9001/video", //视频
//   sosUrlapi: "https://apidev.xin-ptt.com:9001/sos", //sos
//   regionUrlapi: "https://apidev.xin-ptt.com:9001/region", //区域群组
//   enclosureUrlapi:"https://apidev.xin-ptt.com:9001/enclosure",                               //电子围栏
//   getDownPath:"https://apidev.xin-ptt.com:20008",
//   ak: "gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8", //测试定位地址
//   tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
//   socketPz: '49.73.61.229:10001',
//   poc: 'xin'
// };

const baseconfig = {        //正式
    xinextendUrlapi:'https://quan-proxy.xin-ptt.com/extend',
    apiAudioUrl: 'https://quan-proxy.xin-ptt.com/audio',//录音文件平台
    gpsUrlapi: 'https://quan-proxy.xin-ptt.com/gps',//定位地址
    mmsUrlapi: 'https://quan-proxy.xin-ptt.com/mms',//广播
    videoUrlapi: 'https://quan-proxy.xin-ptt.com/video',//视频
    sosUrlapi: 'https://quan-proxy.xin-ptt.com/sos',//sos
    regionUrlapi: "https://quan-proxy.xin-ptt.com/region", //区域群组
    enclosureUrlapi:"https://quan-proxy.xin-ptt.com/enclosure",                               //电子围栏
    selfUrlapi: "https://quan-proxy.xin-ptt.com/xintoc",                         //自建组
    getDownPath:"https://quan-proxy.xin-ptt.com:20008",
    ak: 'gTV5Y1Vvppy3nUFTHQlIBvo5tVx4bqf8',//定位地址
    tokenSl:{ "Content-Type": "application/x-www-form-urlencoded" },
    socketPz: 'quan-disp.xin-ptt.com:10001',
    poc: 'qxptt'
}

export default baseconfig;
